import { curry } from 'lodash/fp';
import getByMode from './getByMode';

export default funcsByMode => curry(getByMode(funcsByMode));
